module.exports = __webpack_public_path__ + "assets/img/tybg.aad0faf9.png";